import { render, staticRenderFns } from "./DonutChart29.vue?vue&type=template&id=1ce99f7c&scoped=true"
import script from "./DonutChart29.vue?vue&type=script&lang=js"
export * from "./DonutChart29.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce99f7c",
  null
  
)

export default component.exports